import { render } from "./StatisticsData.vue?vue&type=template&id=42f7c7b1&scoped=true"
import script from "./StatisticsData.vue?vue&type=script&lang=js"
export * from "./StatisticsData.vue?vue&type=script&lang=js"

import "./StatisticsData.vue?vue&type=style&index=0&id=42f7c7b1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42f7c7b1"]])

export default __exports__